import React, { Component } from "react";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Trans, withTranslation } from "react-i18next";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Select from "@material-ui/core/Select";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import Button from "@material-ui/core/Button";
import InputLabel from "@material-ui/core/InputLabel";
import { DatePicker } from "@material-ui/pickers";
import { Checkbox } from "@material-ui/core";
import FormGroup from "@material-ui/core/FormGroup";
import CoreFilter from "./CoreFilter";
import TaxonomySelector from "./../taxonomy/TaxonomySelector";
import { connect } from "react-redux";
import { Badge } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@mdi/react";
import { mdiFilterVariantRemove, mdiFilterVariant } from "@mdi/js";
import { withStyles } from "@material-ui/core/styles";
import { taxServiceClient } from "../../AxiosClient";
import ListItemText from "@material-ui/core/ListItemText";
import ListItem from "@material-ui/core/ListItem";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import Collapse from "@material-ui/core/Collapse";

const styles = (theme) => ({
  container: {},
  gridContainer: {
    alignItems: "center",
    flexGrow: 1,
  },
  gridItem: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    flexGrow: 1,
    minWidth: theme.spacing(24),
  },
  // filterWrapper: {
  //   flexGrow: 1,
  // },
  filterWrapper: {
    display: "flex",
    alignItems: "center",
    flexGrow: 1,
    width: "100%",
  },
  formControl: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  taxonomyFormControl: {
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  selectMargin: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  userPickerFormControl: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "100%",
  },
});
const StyledBadge = withStyles((theme) => ({
  anchorOriginTopLeftRectangle: {
    transform: "translate(-150%, 50%)",
  },
  badge: {},
}))(Badge);
const equal = require("deep-equal");
const areObjectsEqual = (obj1, obj2) => {
  return equal(obj1, obj2) ? true : false;
};
export class FilterRework extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultFilters: [
        "statusCtrl",
        "urgencyCtrl",
        "raisedByMeCtrl",
        "authoredByMeCtrl",
      ],
      opened: false,
      createdBy: null,
      opened: this.props.isMobile && this.props.menuDialog ? true : false,
      menuCollapseOpened:
        this.props.isMobile && this.props.menuDialog ? false : true,
    };
  }
  componentDidMount() {
    if (this.props.filter.createdBy && this.props.filter.createdBy.length > 0) {
      taxServiceClient
        .post("/user/userlist", { userIds: this.props.filter.createdBy })
        .then((res) => {
          this.setState({ createdBy: res.data });
        });
    }
  }
  componentDidUpdate(_prevProps, prevState) {
    if (
      !areObjectsEqual(this.props.filter.createdBy, _prevProps.filter.createdBy)
    ) {
      taxServiceClient
        .post("/user/userlist", { userIds: this.props.filter.createdBy })
        .then((res) => {
          this.setState({ createdBy: res.data });
        });
    }
  }
  toggleExpand = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.isMobile && this.props.menuDialog
      ? this.setState((prev) => ({
          menuCollapseOpened: !prev.menuCollapseOpened,
        }))
      : this.setState((prev) => ({ opened: !prev.opened }));
    //this.setState((prev) => ({ opened: !prev.opened }));
  };
  onCreatedByUpdate = (newUsers) => {
    let event = {};
    event.target = {};
    event.target.name = "createdBy";
    event.target.value = newUsers.map((u) => u.userId);
    this.props.handleChange(event);
  };
  render() {
    const { classes, t, expanded } = this.props;
    let filterObj = {};
    filterObj.sort = 
        this.props.asPopper === true && (
          <div className={classes.sortByContainer}>
            <Typography
              className={classes.sortByLabel}
              style={{ marginTop: 35 }}
            >
              Sort by...
            </Typography>

            <FormControl className={classes.selectMargin}>
              <InputLabel shrink htmlFor="sort">
                <Trans i18nKey="global_sort_by" />
              </InputLabel>
              <Select
                value={this.props.filter.sort}
                onChange={this.props.handleSortChange}
                inputProps={{
                  name: "sort",
                  id: "sort",
                }}
              >
                <MenuItem value="dateCreated">
                  <Trans i18nKey="global_filter_created_date" />
                </MenuItem>
                <MenuItem value="targetCompletionDate">
                  <Trans i18nKey="filter_rework_target_completion_date">
                    filter_rework_target_completion_date
                  </Trans>
                </MenuItem>
                <MenuItem value="urgency">
                  <Trans i18nKey="global_rework_urgency">
                    global_rework_urgency
                  </Trans>
                </MenuItem>
              </Select>
            </FormControl>
            <Button onClick={this.props.toggleSortDirection}>
              {this.props.filter.sortDirection === "ASC" ? (
                <>
                  <ArrowUpwardIcon />
                  <Trans i18nKey="global_ascending" />
                </>
              ) : (
                <>
                  <ArrowDownwardIcon />
                  <Trans i18nKey="global_descending" />
                </>
              )}
            </Button>
          </div>
        )

    filterObj.statusCtrl = (
      <FormControl className={classes.selectMargin}>
        <InputLabel shrink htmlFor="status">
          <Trans i18nKey="filter_rework_status">filter_rework_status</Trans>
        </InputLabel>
        <Select
          value={this.props.filter.status}
          onChange={this.props.handleSelectChange}
          inputProps={{
            name: "status",
            id: "status",
          }}
        >
          <MenuItem value="ALL">
            <Trans i18nKey="filter_rework_status_all">
              filter_rework_status_all
            </Trans>
          </MenuItem>
          <MenuItem value="OPEN">
            <Trans i18nKey="filter_rework_status_open">
              filter_rework_status_open
            </Trans>
          </MenuItem>
          <MenuItem value="RESOLVED">
            <Trans i18nKey="filter_rework_status_resolved">
              filter_rework_status_resolved
            </Trans>
          </MenuItem>
          <MenuItem value="REJECTED">
            <Trans i18nKey="filter_rework_status_rejected">
              filter_rework_status_rejected
            </Trans>
          </MenuItem>
        </Select>
      </FormControl>
    );
    filterObj.urgencyCtrl = (
      <FormControl className={classes.selectMargin}>
        <InputLabel shrink htmlFor="urgency">
          <Trans i18nKey="global_urgency" />
        </InputLabel>
        <Select
          value={this.props.filter.urgency}
          onChange={this.props.handleSelectChange}
          inputProps={{
            name: "urgency",
            id: "expert",
          }}
        >
          <MenuItem value="All">
            <Trans i18nKey="filter_rework_status_all">
              filter_rework_status_all
            </Trans>
          </MenuItem>
          <MenuItem value="High">
            <Trans i18nKey="rework_urgency_high">rework_urgency_high</Trans>
          </MenuItem>
          <MenuItem value="Medium">
            <Trans i18nKey="rework_urgency_medium">rework_urgency_medium</Trans>
          </MenuItem>
          <MenuItem value="Low">
            <Trans i18nKey="rework_urgency_low">rework_urgency_low</Trans>
          </MenuItem>
        </Select>
      </FormControl>
    );
    filterObj.taxonomy = (!this.props.filter.documentId || this.props.filter.documentId === 0) && (
      <FormControl className={classes.taxonomyFormControl}>
        {this.props.isFilterSet("taxonomy") && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <TaxonomySelector
          limitWithTeam
          multiSelect={true}
          allowedSelections={["taxonomy"]}
          filter={this.props.getTaxonomy(
            this.props.filter.taxonomy,
            this.props.taxonomyNodeLookup
          )}
          onNodeSelected={this.props.setTaxonomy}
        />
      </FormControl>
    )
    filterObj.createdBeforeCtrl = (
      <FormControl className={classes.selectMargin}>
        <DatePicker
          autoOk
          label={t("filter_discussions_created_before")}
          clearable
          disableFuture
          value={
            this.props.filter.createdBefore
              ? this.props.filter.createdBefore
              : null
          }
          onChange={this.props.handleDateChange("createdBefore")}
        />
      </FormControl>
    );
    filterObj.createdAfterCtrl = (
      <FormControl className={classes.selectMargin}>
        <DatePicker
          autoOk
          label={t("filter_discussions_created_after")}
          clearable
          disableFuture
          value={
            this.props.filter.createdAfter
              ? this.props.filter.createdAfter
              : null
          }
          onChange={this.props.handleDateChange("createdAfter")}
        />
      </FormControl>
    );
    filterObj.targetBeforeCtrl = (
      <FormControl className={classes.selectMargin}>
        <DatePicker
          autoOk
          label={t("filter_rework_target_before")}
          clearable
          value={
            this.props.filter.targetCompletionDateBefore
              ? this.props.filter.targetCompletionDateBefore
              : null
          }
          onChange={this.props.handleDateChange("targetCompletionDateBefore")}
        />
      </FormControl>
    );
    filterObj.targetAfterCtrl = (
      <FormControl className={classes.selectMargin}>
        <DatePicker
          autoOk
          label={t("filter_rework_target_after")}
          clearable
          value={
            this.props.filter.targetCompletionDateAfter
              ? this.props.filter.targetCompletionDateAfter
              : null
          }
          onChange={this.props.handleDateChange("targetCompletionDateAfter")}
        />
      </FormControl>
    );

    filterObj.raisedByMeCtrl = (
      <FormControlLabel
        control={
          <Checkbox
            checked={this.props.filter.raisedByMe}
            onChange={this.props.handleCheckboxChange("raisedByMe")}
            value={this.props.filter.raisedByMe}
            color="primary"
            id="raisedByMe"
          />
        }
        label={t("filter_rework_raised_by_me")}
      />
    );

    filterObj.authoredByMeCtrl = (!this.props.filter.documentId || this.props.filter.documentId === 0) && (
      <FormControlLabel
        control={
          <Checkbox
            checked={this.props.filter.authoredByMe}
            onChange={this.props.handleCheckboxChange("authoredByMe")}
            value={this.props.filter.authoredByMe}
            color="primary"
            id="authoredByMe"
          />
        }
        label={t("filter_rework_authored_by_me")}
      />
    ) 
    const activeFilters = (
      <>
        {!this.state.opened &&
          Object.keys(this.props.filter)
            .filter((filter) => this.props.isFilterSet(filter))
            .map((filter, idx) => (
              filterObj.hasOwnProperty(filter) &&
                filterObj[filter] &&
                  this.state.defaultFilters.indexOf(filter) < 0 &&
                    <Grid 
                      item
                      xs={
                        filter === "targetBeforeCtrl" ||
                        filter === "targetAfterCtrl" 
                          ? 12
                          : 6
                      }
                      sm={
                        filter === "targetBeforeCtrl" ||
                        filter === "targetAfterCtrl" 
                          ? 6
                          : 3
                      }
                      lg={
                        filter === "targetBeforeCtrl" ||
                        filter === "targetAfterCtrl" 
                          ? 6 
                          : 2
                      }
                      classes={{ root: classes.gridItem }}
                    >
                      {filterObj[filter]}
                    </Grid>
            ))}
      </>
    );
    const inActiveFilters = (
      <>
        {this.state.opened &&
          Object.keys(filterObj).map((filter, idx) => (
            filterObj.hasOwnProperty(filter) &&
                filterObj[filter] &&
                this.state.defaultFilters.indexOf(filter) < 0 &&
                  <Grid 
                    item
                    xs={
                      filter === "targetBeforeCtrl" ||
                      filter === "targetAfterCtrl" 
                        ? 12
                        : 6
                    }
                    sm={
                      filter === "targetBeforeCtrl" ||
                      filter === "targetAfterCtrl" 
                        ? 6
                        : 3
                    }
                    lg={
                      filter === "targetBeforeCtrl" ||
                      filter === "targetAfterCtrl" 
                        ? 6 
                        : 2
                    }
                    classes={{ root: classes.gridItem }}
                  >
                    {filterObj[filter]}
                  </Grid>
          ))}
      </>
    );
    let defaultFilters = (
      <>
          {this.state.defaultFilters.map((filter, idx) => (
            filterObj.hasOwnProperty(filter) && 
              filterObj[filter] &&
              <Grid 
                item
                xs={
                  filter === "targetBeforeCtrl" ||
                  filter === "targetAfterCtrl" 
                    ? 12
                    : 6
                }
                sm={
                  filter === "targetBeforeCtrl" ||
                  filter === "targetAfterCtrl" 
                    ? 6
                    : 3
                }
                lg={
                  filter === "targetBeforeCtrl" ||
                  filter === "targetAfterCtrl" 
                    ? 6 
                    : 2
                }
                classes={{ root: classes.gridItem }}
              >
                {filterObj[filter]}
              </Grid>
          ))}
        
      </>
    );
    return (
      <>
        {this.props.asPopper ? (
          <>
            <div>
              <div className={classes.filterCtr}>
                {this.props.filter !== null &&
                  this.props.filterElement !== null && (
                    <div>
                      {this.props.showReset && (
                        <Button
                          className={classes.resetButton}
                          onClick={this.props.resetToDefaultFilters}
                        >
                          <Trans i18nKey="filters_reset_to_default" />
                        </Button>
                      )}
                      <ExpansionPanel
                        expanded={expanded === "sort"}
                        onChange={this.props.handleExpansionPanelChange("sort")}
                      >
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography className={classes.heading}>
                            <Trans i18nKey="global_sort" />
                          </Typography>
                          <Typography className={classes.secondaryHeading}>
                            <Trans i18nKey="filter_documents_sort_secondary_heading" />
                          </Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                          <div className={classes.sortByContainer}>
                            {filterObj.sort}
                          </div>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>

                      <ExpansionPanel
                        expanded={expanded === "basic"}
                        onChange={this.props.handleExpansionPanelChange(
                          "basic"
                        )}
                      >
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography className={classes.heading}>
                            <Trans i18nKey="global_basic" />
                          </Typography>
                          <Typography className={classes.secondaryHeading}>
                            <Trans i18nKey="filter_rework_basic_secondary_heading" />
                          </Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                          <div>
                            <FormGroup row>
                              {filterObj.statusCtrl}
                              {filterObj.urgencyCtrl}
                            </FormGroup>
                            {this.props.filter.authoredByMe}
                            <FormGroup row>
                              {filterObj.raisedByMeCtrl}
                              {filterObj.authoredByMeCtrl}
                            </FormGroup>
                          </div>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>

                      <ExpansionPanel
                        expanded={expanded === "dates"}
                        onChange={this.props.handleExpansionPanelChange(
                          "dates"
                        )}
                      >
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography className={classes.heading}>
                            <Trans i18nKey="global_sort_dates" />
                          </Typography>
                          <Typography className={classes.secondaryHeading}>
                            <Trans i18nKey="filter_rework_dates_secondary_heading" />
                          </Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                          <FormGroup row>
                            <FormControl className={classes.formControl}>
                              {filterObj.createdBeforeCtrl}
                              {filterObj.createdAfterCtrl}
                            </FormControl>
                            <FormControl className={classes.formControl}>
                              {filterObj.targetBeforeCtrl}
                              {filterObj.targetAfterCtrl}
                            </FormControl>
                          </FormGroup>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>
                      {!this.props.filter.documentId || this.props.filter.documentId === 0 && (
                        <ExpansionPanel
                          expanded={expanded === "sections"}
                          onChange={this.props.handleExpansionPanelChange(
                            "sections"
                          )}
                        >
                          <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon />}
                          >
                            <Typography className={classes.heading}>
                              <Trans i18nKey="global_section_plural" />
                            </Typography>
                            <Typography className={classes.secondaryHeading}>
                              <Trans i18nKey="filter_searches_sections_secondary_heading" />
                            </Typography>
                          </ExpansionPanelSummary>
                          <ExpansionPanelDetails>
                            {filterObj.taxonomy}
                          </ExpansionPanelDetails>
                        </ExpansionPanel>
                      )}
                    </div>
                  )}
              </div>
            </div>
          </>
        ) : (
          <>
            <div>
              <ListItem
                className={classes.listItem}
                style={{
                  paddingLeft: this.props.preText ? 0 : 10,
                  borderRight: this.props.selected
                    ? `2px solid ${this.props.theme.palette.primary.main}`
                    : "",
                }}
                ContainerComponent="div"
                disableGutters={true}
                dense={true}
                selected={false}
              >
                {this.props.preText}
                <ListItemText
                  primary={
                    <>
                      <div className={classes.filterWrapper}>
                        <span>
                          <IconButton
                            onClick={this.props.resetToDefaultFilters}
                            size="large"
                            color={this.props.showReset === true ? "secondary" : "default"}
                            disabled={this.props.showReset === false}
                          >
                            <Icon
                              path={
                                this.props.showReset === true
                                  ? mdiFilterVariantRemove
                                  : mdiFilterVariant
                              }
                              size={1.5}
                            />
                          </IconButton>
                        </span>
                        <div className={classes.filterWrapper}>
                          <Collapse
                            in={this.state.menuCollapseOpened}
                            timeout="auto"
                            unmountOnExit
                            style={{ width: "100%" }}
                          >
                            <Grid
                              container
                              classes={{ root: classes.gridContainer }}
                              style={{
                                flexDirection: this.props.isMobile && "column",
                              }}
                            >
                              {defaultFilters}
                              {activeFilters}
                              <Collapse
                                in={this.state.opened}
                                timeout="auto"
                                unmountOnExit
                                style={{ width: "100%" }}
                              >
                                <Grid
                                  container
                                  classes={{ root: classes.gridContainer }}
                                  style={{
                                    flexDirection:
                                      this.props.isMobile && "column",
                                  }}
                                >
                                  {inActiveFilters}
                                </Grid>
                              </Collapse>
                            </Grid>
                          </Collapse>
                        </div>
                      </div>
                    </>
                  }
                  secondary={""}
                />
                {!this.props.hideExpand && (
                  <IconButton onClick={this.toggleExpand}>
                    {this.state.opened ? (
                      <ExpandLessIcon />
                    ) : (
                      <ExpandMoreIcon />
                    )}
                  </IconButton>
                )}
              </ListItem>
              {/* <Collapse in={this.state.opened} timeout="auto" unmountOnExit>
                <Table size="medium">
                  <>
                    <Grid
                      container
                      spacing="1"
                      classes={{ root: classes.gridContainer }}
                    >
                      {inActiveFilters}
                    </Grid>
                  </>
                </Table>
              </Collapse> */}
            </div>
          </>
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  taxonomyNodeLookup: state.taxonomy.taxonomyNodeLookup,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(CoreFilter(FilterRework))));
